export default __webpack_public_path__ + "static/media/parks-small.293a5cae.svg";